import { mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { ClientNoteCacheMixin } from './ClientNoteCacheMixin'

export const ClientNoteAddMixin = {
  mixins: [ClientNoteCacheMixin],
  data () {
    return {
      noteText: ''
    }
  },
  computed: {
    clientNoteAddModel () {
      return Object.assign({}, this.ownerQueryModel, {
        noteTypeId: this.noteTypeId,
        text: this.noteText
      })
    }
  },
  methods: {
    ...mapActions('RegistrationClientNotes', [
      'addClientNote'
    ]),
    tryAddClientNote () {
      const self = this
      self.error = ''
      return self.addClientNote({ inviteId: self.inviteId, payload: self.clientNoteAddModel })
        .then(response => { self.afterAddClientNote(response.data) })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    afterAddClientNote () {
      // override if necessary
    }
  }
}
